import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface AppConfig {
  quickbooks: {
    enableActions: boolean;
    legacyInvoicesOnly: boolean;
  };
  netsuite: {
    enableActions: boolean;
    enableInvoiceActions: boolean;
    enableEmails: boolean;
    contractorCategoryRefs: string[];
    accountId: string;
  };
  zoho: {
    enableEstimates: boolean;
  };
  oauth: {
    clientID: string;
  };
  enableLegacyAdditionalServices: boolean;
  enableProgressInvoiceCreation: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly defaults: AppConfig = {
    quickbooks: { enableActions: false, legacyInvoicesOnly: false },
    netsuite: { enableActions: false, enableInvoiceActions: false, enableEmails: false, contractorCategoryRefs: [], accountId: '' },
    zoho: { enableEstimates: false },
    oauth: { clientID: '' },
    enableLegacyAdditionalServices: false,
    enableProgressInvoiceCreation: false,
  };

  constructor(private http: HttpClient) { }

  getConfig(): Observable<AppConfig> {
    return this.http.get<any>(`${environment.apiUrl}/config`).pipe(
      map((data) => data.result as AppConfig),
      catchError(() => of(this.defaults)),
    );
  }

  updateConfig(data: Partial<AppConfig>): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/config`, data);
  }
}
